import { InjectedStyledComponent } from '../InjectedStyledComponent';

export default InjectedStyledComponent('select', 'shared', ['select']);